import React from 'react';
import {PixelRatio, StyleProp, StyleSheet, ViewStyle} from 'react-native';
import {Heading, Box, StatusBar, ScrollView} from 'native-base';
import {SafeAreaView} from 'react-native-safe-area-context';
import {GoBackButton} from '../../buttons';
import {message} from './../../../utils/messages';
import {IBackButton} from '../../../interfaces/ui';
import {isWebApp} from '../../../utils/platform/is-web';
interface Props {
  backButton?: IBackButton;
  title: string;
  summary?: string;
  children: JSX.Element[] | JSX.Element;
  contentPaddingX?: string;
  childContainerStyle?: StyleProp<ViewStyle>;
  fixed?: boolean;
}

const titleColor = '#05375a';

const InternalTemplate = (props: Props) => {
  const {
    children,
    title,
    backButton,
    contentPaddingX,
    childContainerStyle,
    fixed,
  } = props;

  const handleBack = () => {
    if (backButton) {
      backButton.onPress();
    }
  };

  return (
    <SafeAreaView style={styles.safeAreaView}>
      <StatusBar barStyle="dark-content" />
      <Box flex={1}>
        <Box
          style={styles.imageBackground}
          _text={{fontSize: 'md', fontWeight: 'bold', color: 'white'}}>
          {backButton && (
            <Box>
              <GoBackButton
                label={backButton.label}
                usage="internal"
                onPress={() => handleBack()}
              />
            </Box>
          )}
          <Box>
            <Heading
              color={titleColor}
              marginTop={35 / PixelRatio.get()}
              marginX="5"
              paddingBottom={34 / PixelRatio.get()}
              size="lg"
              fontWeight="bold">
              {message(title)}
            </Heading>
          </Box>
        </Box>

        {fixed && (
          <Box
            backgroundColor="white"
            borderTopRadius="20"
            paddingTop="5"
            paddingX={contentPaddingX ? contentPaddingX : 4}
            flex={1}>
            {children}
          </Box>
        )}
        {!fixed && (
          <ScrollView
            backgroundColor="white"
            borderTopRadius="20"
            paddingTop="5"
            paddingX={contentPaddingX ? contentPaddingX : 4}
            contentContainerStyle={childContainerStyle}
            showsVerticalScrollIndicator={isWebApp}>
            {children}
          </ScrollView>
        )}
      </Box>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  safeAreaView: {
    backgroundColor: '#f4f9ff',
    flex: 1,
  },
  imageBackground: {
    width: '100%',
    marginTop: 5,
  },
});

export default InternalTemplate;
